import type { Quote } from '@worki/shared';

export function quoteCanEdit(quote: Pick<Quote, 'status' | 'isLocked'>): boolean {
  return !quote.isLocked && (quote.status === 'draft' || quote.status === 'sent');
}

export function quoteWritePayload(payload: Record<string, unknown>, loadedRevision: number | null): Record<string, unknown> {
  return loadedRevision === null ? payload : { ...payload, expectedRevision: loadedRevision };
}
